<template>
    <v-dialog v-if="showDialog" v-model="showDialog" persistent :width="600">
        <div class="common-popup-container">
            <div class="content-wrapper">
                <div class="header-img-wrapper">
                    <div v-if="popupType === 'withoutSave'" class="img-wrapper">
                        <Svg :src="currentDetails.image" fill="#222222"></Svg>
                    </div>
                    <Svg :src="currentDetails.image" :fill="popupType === 'goHome' ? 'none' : '#222222'" v-else></Svg>
                </div>
                <div class="details-wrapper">
                    <h5 class="title">{{ currentDetails.title }}</h5>
                    <p class="subtitle" v-if="currentDetails?.subtitle">{{ currentDetails.subtitle }}</p>
                </div>
            </div>
            <div class="common-popup-footer">
                <button class="cancel" @click="closePopup">{{ currentDetails.yesBtnDetail === 'Logout' ? 'No, Stay Back'
                    :
                    'Cancel' }}</button>
                <button class=" cancel yes-btn" @click="confirmAction">Yes, {{ currentDetails.yesBtnDetail }}</button>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DeleteIcon from '@/assets/icons/delete.svg';
import SaveIcon from '@/assets/icons/save.svg';
import LogoutIcon from '@/assets/icons/logout.svg';
import CloseIcon from '@/assets/icons/close.svg';
import SwitchIcon from '@/assets/icons/switch.svg';
import HomeIcon from '@/assets/icons/popup-home.svg';
export default {
    props: {
        showCommonPopup: {
            type: Boolean,
            default: false,
        },
        popupType: {
            type: String,
        },
    },
    data() {
        return {
            showDialog: this.showCommonPopup,
            deleteDetails: {
                image: DeleteIcon,
                title: 'Are you sure you want to discard this document?',
                subtitle: 'All the data entered will be deleted.',
                yesBtnDetail: 'Discard',
            },
            deleteAllDetails: {
                image: DeleteIcon,
                title: 'Are you sure you want to discard all the comments?',
                subtitle: 'All the data entered will be deleted.',
                yesBtnDetail: 'Discard',
            },
            deleteComment: {
                image: DeleteIcon,
                title: 'Are you sure you want to the comment?',
                subtitle: 'All the data entered will be deleted.',
                yesBtnDetail: 'Discard',
            },
            SaveDetails: {
                image: SaveIcon,
                title: 'Are you sure you want to save this document as draft?',
                subtitle: 'All the data entered will be saved.',
                yesBtnDetail: 'Save as Draft',
            },
            logoutDetails: {
                image: LogoutIcon,
                title: 'Are you sure you want logout from this session?',
                yesBtnDetail: 'Logout',
            },
            withoutSaveDetails: {
                image: CloseIcon,
                title: 'You have unsaved changes. Are you sure you want to exit without saving?',
                subtitle: 'All the data entered will be deleted',
                yesBtnDetail: 'Exit Without Saving',
            },
            switchVersionWithoutSaveDetails: {
                image: SwitchIcon,
                title: 'Are you sure you want to switch to another version without saving?',
                subtitle: 'All the data entered will be deleted',
                yesBtnDetail: 'Switch Without Saving',
            },
            goHomeDetails: {
                image: HomeIcon,
                title: 'Are you sure you want to cancel the process and go back home?',
                subtitle: 'All the data entered will be lost',
                yesBtnDetail: 'Go Home',
            },
            currentDetails: {},
        };
    },
    watch: {
        showCommonPopup: {
            immediate: true,
            handler() {
                if (this.showCommonPopup) {
                    this.setCurrentDetails();
                }
            }

        },
    },
    methods: {
        setCurrentDetails() {
            if (this.popupType === 'delete') {
                this.currentDetails = this.deleteDetails;
            } else if (this.popupType === 'saveAsDraft') {
                this.currentDetails = this.SaveDetails;
            }
            else if (this.popupType === 'logout') {
                this.currentDetails = this.logoutDetails;
            }
            else if (this.popupType === 'withoutSave') {
                this.currentDetails = this.withoutSaveDetails;
            }
            else if (this.popupType === 'switchVersionWithoutSave') {
                this.currentDetails = this.switchVersionWithoutSaveDetails;
            } else if (this.popupType === 'goHome') {
                this.currentDetails = this.goHomeDetails;
            } else if (this.popupType == 'deleteAll') {
                this.currentDetails = this.deleteAllDetails

            } else if (this.popupType == 'deleteComment') {
                this.currentDetails = this.deleteComment
            }
        },
        closePopup() {
            this.showDialog = false;
            this.$emit('confirm-action', 'no');
        },
        confirmAction() {
            this.showDialog = false;
            this.$emit('confirm-action', 'yes');
        },
    },
}
</script>

<style scoped>
.common-popup-container {
    display: flex;
    flex-direction: column;
    gap: 2em;
    align-items: center;
    background-color: white;
    border-radius: 12px;
    padding: 2em;
    font-family: 'Inter', sans-serif;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1.5em;
    justify-content: center;
    align-items: center;
}

.header-img-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em;
    border-radius: 24px;
    opacity: 0px;
    background: #FAFAFA;
    border: 4px solid #DFDFDF
}

.header-img-wrapper Svg {
    width: 40px;
    height: 40px;
}

.img-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.2em;
    border-radius: 50%;
    opacity: 0px;
    background: #FAFAFA;
    border: 2px solid #222222;
}

.img-wrapper Svg {
    width: 20px;
    height: 20px;
}

.details-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1em;
    align-items: center;
    text-align: center;
}

.title {
    color: #222222;
    font-size: 20px;
    font-weight: 600;
}

.subtitle {
    color: #888888;
    font-size: 14px;
    font-weight: 600;
}

.common-popup-footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 1.5em;
}

.cancel {
    width: 50%;
    padding: 10px 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #404040;
    cursor: pointer;
    border: 1px solid #A3A3A3;
    border-radius: 8px;
}

.yes-btn {
    background-color: #222222;
    color: #FFFFFF;
}
</style>